import React from 'react';
import { ClassNameProp } from '../common-types';
import { intl } from '../../lib';

/**
 * Props for a {@link NameCircle} component.
 */
export interface NameCircleProps extends ClassNameProp {
  /**
   * Person firstName.
   */
  firstName?: string;
  /**
   * Person lastName.
   */
  lastName?: string;
}

/**
 * Component for displaying the initials of a person's name in a colored circle.
 *
 * @param properties a {@link NameCircleProps} object
 * @return the created {@link JSX.Element}.
 * @author agd
 * @constructor
 */
export function NameCircle({
  firstName = '',
  lastName = '',
  className = ''
}: NameCircleProps): JSX.Element {
  const nameLetters =
    firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
  const colorLetter = nameLetters.charAt(0);

  return (
    <div
      className={`ehs-name-circle nameCircleColor${colorLetter} ${className}`.trim()}
      aria-label={intl('common.name.initials')}
    >
      {nameLetters}
    </div>
  );
}
